import { MiniCertificate, useUserCertificates } from 'features/Certificate'
import React from 'react'

const Certificates = (props: { user_id: number }) => {
  const { user_id } = props
  const { data: certificates, isLoading } = useUserCertificates(user_id)

  if (isLoading || !certificates) {
    return (
      <div className="bg-zinc-800 p-3 my-3 rounded">
        <div className="animate-spin h-24 w-24 rounded-full border-b border-white mx-auto" />
      </div>
    )
  }

  if (certificates && certificates.length === 0) {
    return <></>
  }

  return (
    <div className="p-0.5 rounded-md bg-gradient-to-br from-indigo-400 via-zinc-700 to-zinc-500">
      <div className="flex flex-col space-y-3 bg-zinc-800 rounded-md p-3">
        <div className="text-2xl font-bold pl-2">Certificates</div>
        <div className="flex flex-wrap rounded-md">
          {certificates &&
            certificates.map((certificate) => (
              <a
                key={certificate.cuid}
                href={`/certificate/${certificate.cuid}`}
                target="_blank"
                rel="noopener noreferrer"
                className="m-3 mt-0">
                <MiniCertificate
                  title={certificate.title || 'Certificate'}
                  cuid={certificate.cuid}
                  type={certificate.certificate_type}
                />
              </a>
            ))}
        </div>
      </div>
    </div>
  )
}

export default Certificates
